export default "__VITE_ASSET__3280a021__"